import controller from './fill.controller';
import template from './fill.pug';

const FillComponent = {
  template,
  controller,
  bindings: {
    case: '<',
  },
};

export default FillComponent;



// WEBPACK FOOTER //
// ./client/app/cases/fill/fill.component.js